import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";

import { useCombinedContext } from "../../context/CombinedContext";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import StockOutView from "./StockOutView";
import StockOutForm from "./StockOutForm";


const StockOutList = () => {
  const [stockout, setStockOut] = useState([]);
  const [vessel, setVessel] = useState([]);

  const [filterData, setFilterData] = useState([]);
  const [fromDate, setFromDate] = useState(""); // Start date for filtering
  const [toDate, setToDate] = useState(""); // End date for filtering
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedYear, setSelectedYear] = useState(""); // For year-wise filtering
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const { selectedCompany } = useCombinedContext();
  const companyId = selectedCompany?._id;
  const companyCode = selectedCompany?.company_code;

  // console.log("for gst",selectedCompany)
  // console.log(stockout, "StockOut data  for excel");
  //  console.log("companyId: ", companyId);
  // console.log("vessel", vessel)

  const fetchStockOut = async () => {
    try {
      setLoading(true);
      setTimeout(() => { }, 100000);
      const params = {};
      if (fromDate) params.start_date = fromDate;
      if (toDate) params.end_date = toDate;

      const response = await axiosInstance.get(
        `/logistics/stockout/${companyId}`,
        {
          params,
        },
      );
      setStockOut(response.data.stockOuts || []);
      console.log(response);
      setFilterData(response.data.stockOuts || []);
      // console.log("Stockout", response.data);
    } catch (error) {
      // console.error("Error fetching stockout:", error);
      toast.error("Error fetching stockout");
    } finally {
      setLoading(false);
    }
  };
  /* 
  const fetchVessel = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/logistics/stockOut/vessel/company/${companyId}`,
      );
      setVessel(response.data.vessels || []);
      // console.log("Vessel", response);
      // console.log("companyId: ", companyId);
    } catch (error) {
      // console.error("Error fetching stockout:", error);
      toast.error("Error fetching Vessel");
    } finally {
      setLoading(false);
    }
  }; */

  useEffect(() => {
    if (companyId) {
      fetchStockOut();
    }
  }, [companyId, fromDate, toDate]);

  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = stockout.filter(
      (stockout) =>
        stockout.employeeId?.name
          .toString()
          .toLowerCase()
          .includes(searchText) ||
        stockout.employeeId?.employeeNo
          .toString()
          .toLowerCase()
          .includes(searchText) ||
        stockout.vesselId?.vessel_name
          .toString()
          .toLowerCase()
          .includes(searchText) ||
        stockout.vesselId?.vessel_code
          .toString()
          .toLowerCase()
          .includes(searchText),
    );
    setFilterData(filteredLocation);
  };

  /*   const deleteCompany = async (_id) => {
    try {
      await axiosInstance.delete(`/logistics/stockout/${_id}`);
      fetchStockOut();
    } catch (error) {
      // console.error("Error deleting company:", error);
      toast.error("Failed to delete conpany");
    }
  }; */

  const handleDelete = (id) => {
    // console.log("delete", id);
    setDeleteTarget(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await axiosInstance.delete(`/logistics/stockout/${deleteTarget}`);
      setStockOut((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setFilterData((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setIsDeleteModalOpen(false);
      setDeleteTarget(null);
      toast.success("Location deleted successfully");
    } catch (error) {
      // console.error("Error deleting location:", error);
      toast.error("Failed to delete location");
    }
  };

  // Get data from selected year
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    if (year) {
      setFromDate(`${year}-01-01`);
      setToDate(`${year}-12-31`);
    } else {
      setFromDate("");
      setToDate("");
    }
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // const itemsPerPage = 5;
  const currentStockOutItems = [...filterData]
    .reverse()
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const pageCount = Math.ceil(filterData.length / itemsPerPage);

  // Check Role

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;
  const buildLocationLabel = (location) => {
    return [
      location?.code,
      location?.yard_name,
      location?.address,
      location?.country,
      location?.pincode,
    ]
      .filter(Boolean)
      .join(", ");
  };
  const handleExport = () => {
    const sheetData = [];
    const merges = [];

    // Define header rows
    // Row 0: Main headers. The "Stocks" header will span across columns 6 to 9.
    sheetData.push([
      "Sl No",
      "Employee Name",
      "Employee No",
      "Date",
      "Year",
      "Location",
      "Stocks", // This header spans multiple columns
      "", // Placeholder for Description
      "", // Placeholder for Quantity
      "", // Placeholder for Stock No
      "Remarks",
    ]);

    // Row 1: Sub-headers for the Stocks section.
    sheetData.push([
      "",
      "",
      "",
      "",
      "",
      "",
      "Part No",
      "Stock Name",
      "Description",
      "Available Qty",
      "Used Quantity",
      "Remaining Qty",
      "",
    ]);

    // Merge cells for the headers that do not have sub-headers.
    merges.push(
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Sl No
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // Employee Name
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // Employee No
      { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // Date
      { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } }, // Vessel Name
      { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // Vessel Code
      { s: { r: 0, c: 12 }, e: { r: 1, c: 12 } }, // Remarks
    );

    // Merge the "Stocks" header across columns 6 to 9.
    merges.push({ s: { r: 0, c: 6 }, e: { r: 0, c: 11 } });

    // Process each stockout record
    filterData.forEach((record, index) => {
      const startRow = sheetData.length; // starting row index for this record
      // Format the date
      const formattedDate = record.date
        ? new Date(record.date).toLocaleDateString()
        : "N/A";
      const year = record.date ? new Date(record.date).getFullYear() : "N/A";

      // Employee details
      const empName = record.employeeId?.name || "N/A";
      const empNo = record.employeeId?.employeeNo || "N/A";
      const locationLabel = buildLocationLabel(record.locationId) || "N/A";
      const remarks = record.remarks || "";

      // Loop through each stock in the record
      record.stocks.forEach((stockItem, itemIndex) => {
        sheetData.push([
          // Only show record-level info for the first row of this record.
          itemIndex === 0 ? index + 1 : "",
          itemIndex === 0 ? empName : "",
          itemIndex === 0 ? empNo : "",
          itemIndex === 0 ? formattedDate : "",
          itemIndex === 0 ? year : "",
          itemIndex === 0 ? locationLabel : "",
          stockItem.stock?.stockNo || "",
          stockItem.stock?.name || "N/A",
          stockItem.stock?.description || "",
          stockItem.beforeQty || 0,
          stockItem.quantity,
          stockItem.afterQty || 0,
          itemIndex === 0 ? remarks : "",
        ]);
      });

      const endRow = sheetData.length - 1;
      // If a record contains multiple stock items, merge the record-level cells vertically.
      if (record.stocks.length > 1) {
        [0, 1, 2, 3, 4, 5, 12].forEach((col) => {
          merges.push({ s: { r: startRow, c: col }, e: { r: endRow, c: col } });
        });
      }
    });

    // Convert the array of arrays into a worksheet.
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    // Apply the merges
    worksheet["!merges"] = merges;

    // (Optional) Apply basic cell styling, such as bold headers and borders.
    Object.keys(worksheet).forEach((cellKey) => {
      if (cellKey[0] === "!") return;
      // Make headers bold for the first two rows.
      const cell = worksheet[cellKey];
      const cellAddress = XLSX.utils.decode_cell(cellKey);
      if (cellAddress.r < 2) {
        cell.s = {
          font: { bold: true },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    // Create a new workbook and append the worksheet.
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate a binary string representation of the workbook.
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    // Create a Blob and trigger the download.
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, "exported_stockout_data.xlsx");
  };

  /*   function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } */
  const requestApproval = async (id) => {
    try {
      await axiosInstance.post(`/logistics/stockout/request-approval/${id}`);
      toast.success("Approval requested");
      fetchStockOut();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error");
    }
  };

  const approveStockOut = async (id) => {
    try {
      await axiosInstance.patch(`/logistics/stockout/approve/${id}`);
      toast.success("Approved successfully");
      fetchStockOut();
    } catch (err) {
      toast.error("Failed to approve");
    }
  };

  return (
    <div>
      <ToastContainer />

      <div className="mb-4 headStyle d-flex  justify-content-between align-items-center">
        <h4 className="mb-0">Stock Out</h4>
        <button
          className="button-2"
          onClick={() => {
            if (selectedCompany?.status === false) {
              toast.error(
                "The selected company is inactive. Cannot add a stockout.",
              );
            } else {
              setSelectedData(null);
              setShowForm(true);
            }
          }}
          style={{
            borderRadius: "8px",
            whiteSpace: "nowrap",
            padding: "8px 16px",
          }}
        >
          Add StockOut
        </button>
      </div>
      <div className="headStyle">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <label
                htmlFor="fromDate"
                style={{ width: "-webkit-fill-available" }}
              >
                From Date
              </label>
              <input
                className="form-control"
                type="date"
                placeholder="From Date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <label
                htmlFor="fromDate"
                style={{ width: "-webkit-fill-available" }}
              >
                To Date
              </label>
              <input
                className="form-control"
                type="date"
                placeholder="To Date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div style={{ flex: "0 1 auto" }}>
              <select
                className="form-select"
                value={selectedYear}
                onChange={handleYearChange}
                // size={30}
                style={{
                  width: "70px", // Adjust the width
                  maxHeight: "300px !importent", // Limit the height of the dropdown
                  overflowY: "auto", // Add scroll for long lists
                }}
              >
                <option value="">Year</option>
                {Array.from(
                  { length: new Date().getFullYear() - 2000 + 1 },
                  (_, i) => 2000 + i,
                ).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div>


          </div>
        </div>
      </div>
      <div className="headStyle mt-4 ">
        <div className="d-flex mt-2 flex-wrap align-items-center gap-3 justify-content-between">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div>
              <input
                className="form-control"
                type="search"
                placeholder="Search..."
                style={{
                  maxWidth: "100%",
                  border: "1px solid #1E2A5E",
                  borderRadius: "8px",
                }}
                onChange={handleSearchChange}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="me-2 pt-1">Count</label>
              <select
                className="form-select no-arrow"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                style={{ width: "auto" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
          <div style={{ flex: "0 1 auto" }}>
            <button className="button-2" onClick={handleExport}>
              Export to Excel
            </button>
          </div>

        </div>
        <div
          className="my-3 rounded table-responsive-sm"
          style={{
            overflowX: "auto",
          }}
        >
          <table id="my-table" className="table table-bordered mb-0">
            <thead className="t_head">
              <tr className="text-center align-middle">
                {/* Table Headers */}
                <th className="align-middle">Sl No</th>
                <th className="align-middle">Employee Name</th>
                <th className="align-middle">Employee No</th>
                <th className="align-middle">Date</th>
                <th className="align-middle">Location</th>

                <th className="align-middle">Remarks</th>
                <th className="align-middle">Status</th>
                <th className="text-center align-middle ">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentStockOutItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="15">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentStockOutItems &&
                        currentStockOutItems.map((stockout, index) => (
                          <tr key={stockout._id || index}>
                            {/* Table Data */}
                            <td style={{ textAlign: "center" }}>
                              {currentPage * itemsPerPage + index + 1}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {stockout.employeeId?.name || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {stockout.employeeId?.employeeNo || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {stockout.date
                                ? new Date(stockout.date).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>
                              {[
                                stockout.locationId?.code,
                                stockout.locationId?.yard_name,
                                stockout.locationId?.address,
                                stockout.locationId?.country,
                                stockout.locationId?.pincode,
                              ]
                                .filter(Boolean)
                                .join(", ") || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {stockout.remarks || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {stockout.editRequestPending
                                ? "🔴 Pending"
                                : stockout.editApproved
                                  ? "🟢 Approved"
                                  : "—"}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                {["admin", "superadmin"].includes(userRole) && (
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => {
                                      setSelectedData(stockout);
                                      setIsViewMode(true);
                                    }}
                                  >
                                    <i className="bi bi-folder2-open"></i>
                                  </button>
                                )}
                                {!(
                                  userRole === "user" &&
                                  stockout.userEditCount > 0 &&
                                  !stockout.editApproved
                                ) && (
                                    <button
                                      className="btn btn-outline-success btn-sm"
                                      onClick={() => {
                                        setSelectedData(stockout);
                                        setShowForm(true);
                                      }}
                                    >
                                      <i className="bi bi-pencil-square"></i>
                                    </button>
                                  )}
                                {userRole === "user" &&
                                  stockout.userEditCount > 0 &&
                                  !stockout.editApproved && (
                                    <>
                                      {stockout.editRequestPending ? (
                                        <span
                                          style={{
                                            background: "red",
                                            color: "white",
                                            padding: "5px 10px",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          Pending Approval
                                        </span>
                                      ) : (
                                        <button
                                          className="btn btn-warning btn-sm"
                                          onClick={() =>
                                            requestApproval(stockout._id)
                                          }
                                        >
                                          Request Approval
                                        </button>
                                      )}
                                    </>
                                  )}
                                {["admin", "superadmin"].includes(userRole) &&
                                  stockout.editRequestPending && (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        approveStockOut(stockout._id)
                                      }
                                    >
                                      Approve
                                    </button>
                                  )}{" "}
                                {["admin", "superadmin"].includes(userRole) && (
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => handleDelete(stockout._id)}
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />
        {isViewMode && (
          <StockOutView
            stockout={selectedData}
            isViewMode={isViewMode}
            userRole={userRole}
            setIsViewMode={setIsViewMode}
          />
        )}
        {showForm && (
          <StockOutForm
            stockout={selectedData}
            companyCode={companyCode}
            companyId={companyId}
            vessel={vessel}
            selectedCompany={selectedCompany}
            onClose={() => {
              setShowForm(false);
              fetchStockOut();
            }}
          />
        )}
        {isDeleteModalOpen && (
          <div
            className={`modal fade ${isDeleteModalOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="deleteModalLabel"
            aria-hidden={!isDeleteModalOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal"))
                setIsDeleteModalOpen(false);
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body modalWhite">
                  Are you sure you want to delete this StockOut? This action
                  cannot be undone.
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockOutList;
